/* Collapsible groups inside Brown Butter filter lists (snippets/bb-facet-values.liquid), used by Shop All and
   the collection pages. The server expands a group that holds a selection; a group the shopper opens or
   closes keeps that state when facets.js re-renders the filters after each change. */
(() => {
  if (window.BBFacetGroups) return;
  window.BBFacetGroups = true;

  const state = new Map(); // data-group-key -> expanded (only groups the shopper toggled)

  const setExpanded = (group, expanded) => {
    group.classList.toggle('is-collapsed', !expanded);
    const toggle = group.querySelector(':scope > .bb-facet-group__toggle');
    if (toggle) toggle.setAttribute('aria-expanded', String(expanded));
  };

  const toggleGroup = (toggle) => {
    const group = toggle.closest('.bb-facet-group');
    if (!group) return;
    const expanded = toggle.getAttribute('aria-expanded') !== 'true';
    state.set(group.dataset.groupKey, expanded);
    // Desktop and mobile render the same groups; keep them in step.
    document
      .querySelectorAll(`.bb-facet-group[data-group-key="${CSS.escape(group.dataset.groupKey)}"]`)
      .forEach((g) => setExpanded(g, expanded));
  };

  const restore = () => {
    if (!state.size) return;
    document.querySelectorAll('.bb-facet-group[data-group-key]').forEach((group) => {
      if (state.has(group.dataset.groupKey)) setExpanded(group, state.get(group.dataset.groupKey));
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.bb-facet-group__toggle');
    if (toggle) toggleGroup(toggle);
  });

  document.addEventListener('keydown', (event) => {
    const toggle = event.target.closest && event.target.closest('.bb-facet-group__toggle');
    if (!toggle || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    toggleGroup(toggle);
  });

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 && (node.matches('.bb-facet-group, [class*="facets"]') || node.querySelector('.bb-facet-group'))) {
          restore();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
